import { Component, OnInit, Input, PLATFORM_ID, Inject, AfterViewInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { BreadcrumbData } from "../breadcrumb/breadcrumb.component";
import { IBannerImageListDataModel } from "../../models/banner-image-list.datamodel";
import { CustomDeviceDetectorService } from "../../services/custom-device-detector.service";
//import { ActivatedRoute, Router } from '@angular/router';
import { JssStylingService } from "../../jss-styling.service";
//import { PbJssLayoutService } from '../../layout/pb-jss-layout.service';
import { isPlatformServer, DOCUMENT } from "@angular/common";
import { Subscription } from "rxjs";
import { ThemeService } from "../../services/theme.service";
import { PageScrollService } from "ngx-page-scroll-core";
import { JssContextService } from '../../jss-context.service';
@Component({
  selector: 'app-account-product-page-module',
  templateUrl: './account-product-page-module.component.html',
  styleUrls: ['./account-product-page-module.component.scss']
})
export class AccountProductPageModuleComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  _isPlatformServer: boolean = false;
  breadcrumbData = {} as BreadcrumbData;
  bannerImageListData: IBannerImageListDataModel;
  public isMobile: boolean = false;
  public CardData: any;
  public containerClass: any;
  dynamicClass: string;
  public energySave: boolean = false;
  hasModal: boolean = false;
  energySaveSubscription: Subscription;
  highlight: boolean = false;
  public contextSubscription: Subscription;
  language:string;
  //public cardTemplateId: string;

  constructor(
      private pageScrollService: PageScrollService,
      @Inject(DOCUMENT) private document: any,
      private cdr: ChangeDetectorRef,
      @Inject(PLATFORM_ID) public readonly platformId: string,
      public themeService: ThemeService,
      private deviceDetector: CustomDeviceDetectorService,
      public jssContext: JssContextService,
      public jssStylingService: JssStylingService
  ) {
      platformId;
  }

  ngOnInit() {
      this._isPlatformServer = isPlatformServer(this.platformId);

          this.isMobile = this.deviceDetector.isMobile();

          this.contextSubscription = this.jssContext.state.subscribe((newState) => {
            this.language = newState.language
          });

          this.energySaveSubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
              this.energySave = energySave;
          });
          this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
          this.CardData = (this.rendering?.fields as any)?.Account[0]?.fields;
         // this.cardTemplateId = (this.rendering?.fields as any)?.result["CardTemplateId"]?.toUpperCase();
          this.breadcrumbData.items = (this.rendering?.fields?.result as any)?.["BreadcrumbData"];
          this.isMobile = this.deviceDetector.isMobile();
          this.containerClass = "lg:pb-flex-row-reverse";
          if(this.CardData.MinimumAmountValue?.value =="" && this.CardData.DurationValue?.value =="" && this.CardData.RateValue?.value =="" && this.CardData.InterestReturnValue?.value ==""){
            this.highlight = false;
          }
          else{
            this.highlight = true;
          }
  }

  scrollToAnchor(anchorId: string): void {
    if (!this._isPlatformServer) {
      if (anchorId) {
          this.pageScrollService.scroll({
              document: this.document,
              scrollTarget: "#" + anchorId,
              scrollOffset: 120,
              duration: 300,
          });
      }
    }
  }
  ngAfterViewInit() {
      if (!this._isPlatformServer) {
          setTimeout(() => {
              this.hasModal = document.querySelector(".pb-contact-modal") != null;
              this.cdr.detectChanges();
          }, 0);
      }
  }
  ngOnDestroy(): void {
      if (!this._isPlatformServer) {
        if(this.energySaveSubscription){
            this.energySaveSubscription.unsubscribe();
        }
        if (this.contextSubscription) {
            this.contextSubscription.unsubscribe();
        }
    
      }
  }

  openModal(event: Event): void {
      event.preventDefault();
      if (!this._isPlatformServer && this.hasModal) {
          document.querySelector<HTMLElement>("body").classList.add("pb-overflow-y-hidden");
          this.fadeIn(document.querySelector(".pb-contactFormModal") as HTMLElement);
          document.querySelector(".pb-contact-modal").classList.remove("transform-out");
          document.querySelector(".pb-contact-modal").classList.add("transform-in");
      }
  }

  fadeIn(element: HTMLElement) {
      if (!this._isPlatformServer) {
          let duration = 500;
          element.style.display = "block";
          element.style.opacity = "0";
          let opacity = 0;

          const interval = 16;
          const increment = interval / duration;

          function tick() {
              opacity += increment;
              element.style.opacity = String(opacity);

              if (opacity >= 1) {
                  clearInterval(timer);
              }
          }

          const timer = setInterval(tick, interval);
      }
  }
}
